export const genrerList = [
  { key: 0, label: 'SEM INFO', value: 'NA', code: 'SX00' },
  { key: 1, label: 'MASCULINO', value: 'male', code: 'SX01' },
  { key: 2, label: 'FEMININO', value: 'female', code: 'SX02' },
  { key: 3, label: 'OUTROS', value: 'other', code: 'SX03' },
];

export const LevelList = [
  { key: 0, label: 'SEM INFO', value: 'NA', code: 'NT00' },
  { key: 1, label: 'SEDENTÁRIO', value: 'sedentario', code: 'NT01' },
  { key: 2, label: 'INICIANTE', value: 'iniciante', code: 'NT02' },
  { key: 3, label: 'INTERMEDIÁRIO', value: 'intermediario', code: 'NT03' },
  { key: 4, label: 'AVANÇADO', value: 'avancado', code: 'NT04' },
  { key: 5, label: 'ATLETA', value: 'atleta', code: 'NT05' },
];

export const objectiveList = [
  { key: 0, label: 'SEM INFO', value: 'NA', code: 'OT00' },
  { key: 1, label: 'CONDICIONAMENTO', value: 'condicionamento', code: 'OT01' },
  { key: 2, label: 'EMAGRECIMENTO', value: 'emagrecimento', code: 'OT02' },
  { key: 3, label: 'ESTÉTICA', value: 'estetica', code: 'OT03' },
  { key: 4, label: 'HIPERTROFIA', value: 'hipertrofia', code: 'OT04' },
  {
    key: 5,
    label: 'QUALIDADE DE VIDA',
    value: 'qualidadedevida',
    code: 'OT05',
  },
];

export const frequencyList = [
  { key: 0, label: 'SEM INFO', value: 'NA', code: 'FQ00' },
  { key: 1, label: '1X', value: '1X', code: 'FQ01' },
  { key: 2, label: '2X', value: '2X', code: 'FQ02' },
  { key: 3, label: '3X', value: '3X', code: 'FQ03' },
  { key: 4, label: '4X', value: '4X', code: 'FQ04' },
  { key: 5, label: '5X', value: '5X', code: 'FQ05' },
  { key: 6, label: '6X', value: '6X', code: 'FQ06' },
  { key: 7, label: '7X', value: '7X', code: 'FQ07' },
];

export const availableTimeList = [
  { key: 0, label: 'SEM INFO', value: 'NA', code: 'TA00' },
  { key: 1, label: '30 MINUTOS', value: '30', code: 'TA01' },
  { key: 2, label: '30-45 MINUTOS', value: '30-45', code: 'TA02' },
  { key: 3, label: '45-60 MINUTOS', value: '45-60', code: 'TA03' },
  { key: 4, label: '60-90 MINUTOS', value: '60-90', code: 'TA04' },
  { key: 5, label: '90 +', value: '90 +', code: 'TA05' },
];

export const avaliationFisic = [
  { key: 0, label: 'SEM INFO', value: 'NA', code: 'AV00' },
  { key: 1, label: 'BAIXO PESO', value: 'baixopeso', code: 'AV01' },
  { key: 2, label: 'PESO NORMAL', value: 'pesonormal', code: 'AV02' },
  { key: 3, label: 'EXCESSO DE PESO', value: 'excessodepeso', code: 'AV03' },
  { key: 4, label: 'OBESIDADE 01', value: 'obesidade01', code: 'AV04' },
  { key: 5, label: 'OBESIDADE 02', value: 'obesidade02', code: 'AV05' },
  { key: 6, label: 'OBESIDADE 03', value: 'obesidade03', code: 'AV06' },
];
